"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Table = require("material-ui/Table");
var _IconButton = _interopRequireDefault(require("material-ui/IconButton"));
var _arrowUpward = _interopRequireDefault(require("material-ui/svg-icons/navigation/arrow-upward"));
var _arrowDownward = _interopRequireDefault(require("material-ui/svg-icons/navigation/arrow-downward"));
var _map2 = _interopRequireDefault(require("lodash/map"));
var _modeEdit = _interopRequireDefault(require("material-ui/svg-icons/editor/mode-edit"));
var _arrowForward = _interopRequireDefault(require("material-ui/svg-icons/navigation/arrow-forward"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var TableGrid = /*#__PURE__*/function (_React$Component) {
  _inherits(TableGrid, _React$Component);
  var _super = _createSuper(TableGrid);
  function TableGrid(props) {
    var _this;
    _classCallCheck(this, TableGrid);
    _this = _super.call(this, props);
    _this.state = {
      items: _this.convertToArray(_this.props.items),
      selected: [],
      sortByColumn: null,
      sortByTypeOptions: ["asc", "desc", "none"],
      sortByTypeKey: 2
    };
    _this.handleRowSelection = _this.handleRowSelection.bind(_assertThisInitialized(_this));
    _this.clickHeaderHandler = _this.clickHeaderHandler.bind(_assertThisInitialized(_this));
    _this.convertToArray = _this.convertToArray.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(TableGrid, [{
    key: "convertToArray",
    value: function convertToArray(object) {
      var _this2 = this;
      var array = [];
      (0, _map2["default"])(object, function (item) {
        array.push(item);
      });
      var state = this.state;
      var sortBy = state ? state.sortByTypeOptions[state.sortByTypeKey] : null;
      if (state && this.props.sortable && sortBy !== "none") {
        array.sort(function (a, b) {
          var selectorKey;
          (0, _map2["default"])(_this2.props.header, function (item, key) {
            if (item.label === state.sortByColumn) {
              selectorKey = key;
            }
          });
          var aValue = a.columns[selectorKey].label;
          var bValue = b.columns[selectorKey].label;
          if (aValue > bValue) return sortBy === "asc" ? 1 : -1;else if (aValue < bValue) return sortBy === "asc" ? -1 : 1;else return 0;
        });
      }
      return array;
    }
  }, {
    key: "clickHeaderHandler",
    value: function clickHeaderHandler(columnName) {
      var newTypeKey = this.state.sortByTypeKey === 2 ? 0 : this.state.sortByTypeKey + 1;
      this.setState({
        sortByTypeKey: newTypeKey,
        sortByColumn: columnName
      });
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        items: this.convertToArray(nextProps.items)
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevState.sortByColumn !== this.state.sortByColumn || prevState.sortByTypeKey !== this.state.sortByTypeKey) {
        this.setState({
          items: this.convertToArray(this.props.items)
        });
      }
    }
  }, {
    key: "isSelected",
    value: function isSelected(index) {
      return this.state.selected.indexOf(index) !== -1;
    }
  }, {
    key: "handleRowSelection",
    value: function handleRowSelection(selectedRows) {
      this.setState({
        selected: selectedRows
      });
      var selectedItems = this.state.items.reduce(function (selectedItems, item, index) {
        if (selectedRows.includes(index)) {
          selectedItems.push(item);
        }
        return selectedItems;
      }, []);
      if (typeof this.props.handleRowSelectionFunc !== "undefined") {
        this.props.handleRowSelectionFunc(selectedRows, selectedItems);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var iconStyles = {
        marginLeft: 12,
        marginBottom: -4,
        height: 18,
        width: 18
      };
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "tablegrid-container"
      }, /*#__PURE__*/_react["default"].createElement(_Table.Table, {
        onRowSelection: this.handleRowSelection,
        multiSelectable: this.props.multiSelectable
        // fixedHeader={false}
        // style={{
        //   "tableLayout": "auto"
        // }}
      }, /*#__PURE__*/_react["default"].createElement(_Table.TableHeader, {
        style: this.props.headerStyle,
        enableSelectAll: this.props.multiSelectable,
        displaySelectAll: this.props.multiSelectable
      }, /*#__PURE__*/_react["default"].createElement(_Table.TableRow, null, (0, _map2["default"])(this.props.header, function (item) {
        return /*#__PURE__*/_react["default"].createElement(_Table.TableHeaderColumn, {
          key: item[_this3.props.idNode],
          style: {
            fontWeight: 600
          }
        }, /*#__PURE__*/_react["default"].createElement("a", {
          onClick: function onClick() {
            return _this3.clickHeaderHandler(item.label);
          }
        }, item.label), _this3.state.sortByColumn === item.label ? _this3.state.sortByTypeKey === 2 ? null : _this3.state.sortByTypeKey === 0 ? /*#__PURE__*/_react["default"].createElement(_arrowUpward["default"], {
          style: iconStyles,
          color: "#9e9e9e"
        }) : /*#__PURE__*/_react["default"].createElement(_arrowDownward["default"], {
          style: iconStyles,
          color: "#9e9e9e"
        }) : null);
      }))), /*#__PURE__*/_react["default"].createElement(_Table.TableBody, null, (0, _map2["default"])(this.state.items, function (item, key) {
        return /*#__PURE__*/_react["default"].createElement(_Table.TableRow, {
          key: key,
          selected: _this3.isSelected(key),
          selectable: item.selectable !== undefined ? item.selectable : true
        }, (0, _map2["default"])(item.columns, function (column) {
          return /*#__PURE__*/_react["default"].createElement(_Table.TableRowColumn, {
            key: column[_this3.props.idNode]
          }, column.label && column.label.substring(0, 4) === "rgba" ? /*#__PURE__*/_react["default"].createElement("div", {
            className: "color-value",
            style: {
              display: "flex"
            }
          }, /*#__PURE__*/_react["default"].createElement("div", {
            className: "color-chip",
            style: {
              marginRight: 6,
              width: 15,
              height: 15,
              backgroundColor: column.label,
              boxShadow: "1px 1px 5px grey"
            }
          }), /*#__PURE__*/_react["default"].createElement("span", {
            dangerouslySetInnerHTML: {
              __html: column.label
            }
          })) : /*#__PURE__*/_react["default"].createElement("span", {
            dangerouslySetInnerHTML: {
              __html: column.label
            }
          }));
        }), typeof _this3.props.viewAction !== "undefined" ? /*#__PURE__*/_react["default"].createElement(_Table.TableRowColumn, {
          style: {
            textAlign: "right"
          }
        }, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
          onClick: function onClick() {
            return _this3.props.viewAction(item[_this3.props.idNode]);
          }
        }, /*#__PURE__*/_react["default"].createElement(_arrowForward["default"], null))) : null, typeof _this3.props.editAction !== "undefined" ? /*#__PURE__*/_react["default"].createElement(_Table.TableRowColumn, {
          style: {
            textAlign: "right"
          }
        }, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
          onClick: function onClick() {
            return _this3.props.editAction(item[_this3.props.idNode]);
          }
        }, /*#__PURE__*/_react["default"].createElement(_modeEdit["default"], null))) : null);
      }))));
    }
  }]);
  return TableGrid;
}(_react["default"].Component);
TableGrid.defaultProps = {
  multiSelectable: false
};
TableGrid.propTypes = {
  idNode: _propTypes["default"].string,
  editAction: _propTypes["default"].func,
  viewAction: _propTypes["default"].func,
  handleRowSelectionFunc: _propTypes["default"].func,
  multiSelectable: _propTypes["default"].bool,
  sortable: _propTypes["default"].bool,
  header: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].array]),
  items: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].array]),
  //Styles
  headerStyle: _propTypes["default"].object
};
var _default = TableGrid;
exports["default"] = _default;